import { useEffect } from 'react';

/**
 * Use to detect clicks outside of a given ref.
 * Pass an array of refs to watch multiple elements.
 */
function useOnOutsideClick(refs, handler) {
    const arrRef = Array.isArray(refs) ? refs : [refs];
    useEffect(() => {
        function listener(event) {
            if (arrRef.some((ref) => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(event.target); })) {
                return;
            }
            handler(event);
        }
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        document.addEventListener('blur', listener);
        return () => {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
            document.removeEventListener('blur', listener);
        };
    }, [refs, handler]);
}

export { useOnOutsideClick };
//# sourceMappingURL=useOnOutsideClick.esm.js.map
